import { useMutation } from "react-query";
import { removeEditedShots } from "components/image-editing/lib/imageData";

export const useDeleteEditedShots = () => {
    return useMutation((shotIds) => removeEditedShots(shotIds));
};
